
document.addEventListener('click', function (event) {
  const button = event.target.closest('#open_form');

  if (!button) return;

  klaviyo.openForm('W368DE');
});
